module.exports = __webpack_public_path__ + "files/35fd11d18f77ad2350e327e80cb6daad.svg";